<template>
  <div class="listContent">
    <a-form :form="form" class="headForm" labelAlign="left">
      <a-row :gutter="24">
        <!-- 基础信息 -->
        <a-col :span="2">
          <a-form-item label="基础信息：">
            <div class="form-text-info"></div>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="动物类型">
            <animal-select style="width: 100%" v-decorator="['animalTypeCode']" />
            <!-- , { rules: [{ required: true, message: '请选择动物类型' }] } -->
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="线路">
            <a-select allowClear v-decorator="['lineId', { rules: [{ required: false, message: '选择线路' }] }]" placeholder="选择线路">
              <a-select-option v-for="el in lineList" :key="el.id" :value="el.id">
                {{el.name}}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="配方类型">
            <a-select size="small" placeholder="全部配方" v-decorator="['formulaType']" style="width: 100%">
              <a-select-option v-for="i in [{name:'全部配方',value: '0'},{name:'配合饲料',value: '1'},{name:'混合日粮',value: '2'}]" :key="i.value">
                {{ i.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="配方分类">
            <a-select allowClear v-decorator="['typeClassify']" style="width: 100%" placeholder="配方分类">
           <a-select-option :value="0"> 未分类 </a-select-option>
            <a-select-option :value="1"> 自产配方 </a-select-option>
            <a-select-option :value="2"> 代工配方 </a-select-option>
            <a-select-option :value="3"> 定制配方 </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <!-- 配方相关 -->
        <a-col :span="2">
          <a-form-item label='配方相关：'>
            <div class="form-text-info"></div>
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="配方">
            <a-input style="width: 100%" @pressEnter="getListHandle" v-decorator="['formulaKeyword']" placeholder="请输入配方名称或者代码" />
          </a-form-item>
        </a-col>
        <a-col :span="5">
          <a-form-item label="原料" style="height: 40px;">
            <a-select
              allowClear
              show-search
              :showArrow="true"
              mode="multiple"
              placeholder="请输入原料名称或者代码"
              style="width: 100%;overflow: auto;margin-top: 9px;"
              size='small'
              :default-active-first-option="false"
              :filter-option="false"
              :not-found-content="null"
              @search="getSearchList"
              @select="onSelect"
              v-decorator="['rawIds']"
              @inputKeydown='inputKeydown'
              :max-tag-count="1"
            >
              <a-select-option v-for="d in searchList" :key="d.id">
                {{d.firstName}}<span style="color: red">{{d.midName}}</span>{{d.lastName}}({{d.code}})
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="7">
          <a-form-item label="编辑日期">
            <a-range-picker v-decorator="['editDateRange']" style="width: 100%" />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <!-- 组织架构 -->
        <a-col :span="2">
          <a-form-item label="组织架构：">
            <div class="form-text-info"></div>
          </a-form-item>
        </a-col>
        <a-col :span="7">
          <a-form-item label="工厂">
            <a-select
              placeholder="请选择工厂"
              size='small'
              v-decorator="['factoryIds']"
              mode="multiple"
              :max-tag-count="1"
              :showArrow="true"
            >
              <a-select-option v-for="i in factoryList" :key="i.factoryId">
                {{ i.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="24">
        <!-- 操作 -->
        <a-col :span="2">
          <a-form-item>
            <div class="form-text-info"></div>
          </a-form-item>
        </a-col>
        <a-col :span="6" class="submitBtnBox" style="">
          <a-button type="primary" class="btnMar" @click="getListHandle">
            查询
          </a-button>
          <a-button type="primary" class="btnMar" :disabled="selectedRowKeys.length !== 2" @click="analyseModalFunc">
            执行对比
          </a-button>
          <a-button v-if="mExport" :loading="downloading" class="btnMar" type="primary" @click="openExport">
            导出数据
          </a-button>
          <a-button class="" @click="resetFields">
            清空
          </a-button>
        </a-col>
      </a-row>
    </a-form>

    <a-table
      ref="listRef"
      id="table-dom"
      :row-key="record =>record.id"
      :loading="loading"
      :columns="columns"
      :data-source="list"
      class="tableBox"
      :pagination="pagination"
      :scroll="{ y, x: 1000 }"
      bordered
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, getCheckboxProps: getCheckboxProps }"
    >
      <template slot="factoryName" slot-scope="text, record">
        {{ record.factoryName }}
      </template>
      <div slot="typeClassify" slot-scope="text">
        {{ typeObj[text] }}
      </div>
    </a-table>

    <Analyse ref="analyse" class="modalBox" :visible.sync="analyseModal" :ary="ary" :selectedAry="selectedAry"/>

    <!-- 导出 -->
    <ExportConfirm :visible="exportVisible" @close="closeExport" :formData="formData"/>
  </div>
</template>
<script>
import { columns, pagination ,columns2} from './config'
import { TpWatermark } from '../utils'

import * as API from './api'
import Analyse from './components/Analyse.vue'
import AnimalSelect from './components/AnimalSelect'
import ExportConfirm from './components/ExportConfirm.vue'
import moment from "moment/moment";
export default {
  name: 'MaterialAnalyse',
  props: {
    menuBtnList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    AnimalSelect,
    Analyse,
    ExportConfirm
  },
  mounted() {
    TpWatermark('table-dom', localStorage.getItem('userName') + ' newhope', '150', '450', '-5', 'grey', '50', '0.06')
    this.y = this.$refs.listRef.$el.offsetHeight - 120
    this.getBtn();
    this.form.setFieldsValue({formulaType: '0'})
    //this.form.setFieldsValue({formulaType: '0'})
  },
  watch: {},
  data() {
    return {
      y: 380,
      typeList: [],
      factoryList: [],
      exportVisible: false,
      formData: {},
      selectedAry: [],
      mExport: false,
      form: this.$form.createForm(this, { name: 'EvalueTool' }),
      confirmLoading: false,
      analyseModal: false, // 是否显示弹窗
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      loading: false,
      downloading: false,
      pagination: {
        ...pagination,
        showSizeChanger: true, // 显示每页条数选择器
        pageSizeOptions: ['10', '20','30','40','50', '100'], // 可选的每页条数
        onChange: (current, size) => {
          this.pagination.current = current
          this.getList({ current, pageSize:size })
        }, //选择页数
        onShowSizeChange: (current, size) => {
          this.pagination.pageSize = size
          this.pagination.current = 1
          this.getList({ current: 1, pageSize:size })
        } //每页多少条
      },
      list: [],
      changedRows: {},
      noMartial: false,
      lineList: [],
      searchList: [],
      ary: [],
      selectedRowKeys: [], // 新增
      selectedRows:[],
      typeObj: {
        0: '未分类',
        1: '自产配方',
        2: '代工配方',
        3: '定制配方',
      },
      // columns
    }
  },
  computed: {
    editColumns() {
      return this.columns.filter(item => item.editable).map(v => v.dataIndex)
    },
    columns(){
      return this.noMartial ? columns : columns2
    }
  },
  created() {
    this.factoryGet()
    this.getTypeList2()
  },
  beforeMount() {
    this.y = window.innerHeight - 400
  },
  methods: {
    getBtn() {
      let factoryId = window.localStorage.getItem('factoryId');
      if (!factoryId) return;
      this.$http.get("/iot-system/menu/buttons", { params: { controlEnd: false, factoryId } }).then(res => {
        let { success, data } = res;
        if (success) {
          data && data.forEach(el => {
            if (el.path === '/fast/MaterialAnalyse') {
              el.children && el.children.forEach(item => {
                if (item.code === 'mExport') this.mExport = true;
              });
            }
          });
        }
      });
    },
    getTypeList2(){
      let params = {
        current: 1,
        size: 10000
      }
      this.$http.get(`/nhf-core-data/line/list`,{params}).then(res => {
        let { success, data } = res
        if (success) {
          let {records} = data || {}
          records&&records.map(el => {
            el.value = el.id
            el.label = el.name
            return
          })
          this.typeList = records || []
          this.getLineList()
        }
      })
    },
    getLineList(){
      let staffId = window.localStorage.getItem('staffId')
      if(!staffId) return
      this.$http.get(`/iot-factory/factorystaffauth/getAnimalIdsInfoByStaffId?StaffId=${staffId}&type=0`).then(data => {
        if(data && data.length > 0){
          data = data.sort((a,b) => a - b)
          let lineList = []
          this.typeList && this.typeList.forEach(el => {
            if(data.includes(el.id)) lineList.push(el)
          })
          this.lineList = lineList
          this.animalRootId = data[0]
          //this.form.setFieldsValue({lineId: data[0] || ''})
        }
      })
    },
    inputKeydown(e){
      if(e.keyCode === 13) this.getList({current:1,pageSize:20})
    },
    onSelect(){
      let rawIds = this.form.getFieldValue('rawIds');
      // this.getList({pageSize:this.pagination.pageSize,current:1,val})
      // 检查选择的数量是否超过20
      if (rawIds && rawIds.length > 20) {
        // 截取前20个选项
        const limitedValue = rawIds.slice(0, 20);
        // 设置表单值为限制后的数组
        this.form.setFieldsValue({
          rawIds: limitedValue
        });
        // 提示用户
        this.$message.warning('原料选择数量已达最大限制20个');
      }
    },
    getSearchList(name){
      if(name){
        setTimeout(() => {
          this.placeStr = name || '请输入原料名称'
          this.form.setFieldsValue({name})
            this.$get('/nhf-core-data/raw/fastRawUserPage', {
              current: 1,
              size:100,
              searchKey:name
            }).then(res => {
              let {success,data} = res;
              if(success){
                let {records} = data || {}
                records.map(el => {
                  let nameArr = el.name.split(name)
                  el.firstName = nameArr[0]
                  el.lastName = nameArr[1]
                  el.midName = name
                  return el
                })
                this.searchList = [...records] || []
              }else{
                this.searchList = []
              }
            }).catch(() => {
              this.searchList = []
            })
        }, 300);
      }
    },
    hasPermission(code) {
      const codes = []
      const fn = ary => {
        ary.forEach(a => {
          codes.push(a.code)
          if (a.children) {
            fn(a.children)
          }
        })
      }
      fn(this.menuBtnList)
      return codes.includes(code)
    },
    disabledFn(row) {
      const limit = 2
      if (this.selectedRowKeys.indexOf(row.id) !== -1) {
        return false
      }
      return this.selectedRowKeys.length >= limit
    },
    filterOption(inputValue, option) {
      try {
        return option.componentOptions.children[0].text.indexOf(inputValue) >= 0
      } catch (e) {
        return false
      }
    },
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1]
      targetOption.loading = true
      setTimeout(() => {
        targetOption.loading = false
        this.getTypeList(targetOption.id, targetOption) || []
      }, 0)
    },

    resetFields() {
      this.selectedRowKeys = [];
      this.selectedRows = [];
      this.selectedAry = [];
      this.form.setFieldsValue({
        formulaType: undefined, formulaName: null, rawIds: undefined, factoryIds: [],
        staffId: null, animalTypeCode: undefined, formulaKeyword: null, lineId: undefined,
        typeClassify: undefined,
        editDateRange: undefined,
      });
    },
    refreshTypeList(data) {
      this.getTypeList(data.id, data.targetOption)
    },
    async getListHandle() {
      const valid = await this.form.validateFields()
      if (!valid) {
        return false
      }
      this.selectedRowKeys = []
      this.pagination.current = 1
      return this.getList(this.pagination)
    },
    async getList(pagination) {
      const valid = await this.form.validateFields()
      if (!valid) {
        return false
      }
      this.loading = true
      let { current = 1, pageSize = 20 } = pagination || this.pagination
      let { factoryIds = [],editDateRange = [],rawIds = [],...newdata } = valid
      let editTimeStart = editDateRange[0] ? moment(editDateRange[0]).format('YYYY-MM-DD 00:00:00') : undefined
      let editTimeEnd = editDateRange[1] ? moment(editDateRange[1]).format('YYYY-MM-DD 23:59:59')  : undefined

      let params = {
        factoryIds: factoryIds.join(','),
        staffId: localStorage.getItem('staffId'),
        rawIds: rawIds.join(','),
        requestType: 2,
        editTimeStart,
        editTimeEnd,
        ...newdata,
        current,
        size: pageSize
      }
      let feild = 'materialsGet2'
      if(params.rawIds){
        feild = 'materialsGet'
        this.noMartial = false
      }
      await API[feild](params)
        .then(res => {
          let { success, data } = res
          if (success) {
            let { records = [], current = 1, total = 0, size = 10 } = data
            this.list = records
            //将lineId映射为名称
            this.list.map(el => {
              let item = this.lineList.find(el2 => el2.id === el.lineId);
              if(item){
                el.lineName = item.name
              }
              return el
            })
            this.pagination.current = current
            this.pagination.total = total
            this.pagination.pageSize = size
          } else {
            this.$message.error('查询失败')
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          e.message && this.$message.error(e.message)
        })
      this.loading = false
    },
    getTypeList(parentId = '0', record, type) {
      this.$http.get(`/nhf-core-data/animal/listByParentId?parentId=${parentId}`).then(res => {
        let { success, data = [] } = res
        if (success) {
          data &&
            data.map(el => {
              el.value = el.id
              el.label = el.name
              el.isLeaf = !el.hasChildren
              return el
            })
          if (record) {
            if (data.length) {
              record.children = data
            } else {
              record.isLeaf = true
            }
            if (!type) {
              this.typeList = [...this.typeList]
            } else {
              this.list = [...this.list]
            }
          } else {
            this.typeList = data
          }
          if(type) {
            this.form.setFieldsValue({lineId: this.typeList[0].children[0].id || ''})
            this.lineList = data
          }
        } else {
          this.typeList = []
        }
        if(parentId === '0'){
          this.getTypeList(this.typeList[0].id,this.typeList[0],true)
        }
      })
    },
    async factoryGet() {
      let params = {
        current: 1,
        size: 100,
      };
      const res = await this.$http.get("/nhf-app/formulaManage/myFactory", { params })
      let { success, data } = res;
      if (success) {
        let { records} = data;
        this.factoryList = records || [];
      }
    },
    async exportFile() {
      const valid = await this.form.validateFields()
      if (!valid) {
        return false
      }

      this.downloading = true
      let { factoryIds = [], ...newdata } = valid
      await API.exportFile({ ...newdata, factoryIds: factoryIds.join(',') }).catch(e => {
        e.message && this.$message.error(e.message)
      })
      this.downloading = false
    },
    async analyseModalFunc() {
      const valid = await this.form.validateFields()
      let formulaIds = []
      let flag = true
      let requestType = 2
      let {lineId} = valid || {}
      this.selectedAry = [];
      this.selectedRows.forEach(row => {
        if (row.rawId) flag = false;
        formulaIds.push(row.id);
        this.selectedAry.push({
          factoryName: row.factoryName,
          formulaName: row.formulaName,
          formulaCode: row.formulaCode
        });
      });
      if(flag){
        await API.materialsGet({
          formulaIds:formulaIds.join(','),lineId,requestType,
          current: 1,size: 5000
        }).then(res => {
          let { success, data } = res
          if(success){
            let {records} = data || {}
            this.ary = records || []
            setTimeout(() => {
              this.analyseModal = !this.analyseModal
            }, 0);
          }
        })
      }else{
        this.ary = this.selectedRows;
        setTimeout(() => {
          this.analyseModal = !this.analyseModal
        }, 0);
      }
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      if (selectedRowKeys.length > 2) {
        this.$message.warning('只能选择2行');
        return;
      }
      this.selectedRowKeys = selectedRowKeys;
      // 维护完整的选中行数据
      // 移除已取消选择的行
      this.selectedRows = this.selectedRows.filter(row =>
          selectedRowKeys.includes(row.id)
      );

      // 添加新选择的行（避免重复添加）
      selectedRows.forEach(row => {
        if (!this.selectedRows.some(selectedRow => selectedRow.id === row.id)) {
          this.selectedRows.push(row);
        }
      });
      console.log('选中的完整数据:', this.selectedRows);
    },
    getCheckboxProps(record) {
      return {
        props: {
          disabled: this.selectedRowKeys.length >= 2 && !this.selectedRowKeys.includes(record.id),
        },
      };
    },
    openExport() {
      this.formData = this.form.getFieldsValue();
      //如果营养指标列表为空，则提示导出必须有原料
      // if(this.formData.rawIds === undefined){
      //   this.$message.error('导出原料列表为空，请先添加原料');
      //   return;
      // }
      this.exportVisible = true;
    },
    closeExport() {
      this.exportVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.listContent {
  .tableBox {
    height: calc(100% - 132px);
    min-height: 240px;
  }
}
.headForm {
  margin-bottom: 10px;
}
// 新增样式
.form-text-info {
  font-size: 12px;
  display: flex;
  align-items: center; /* 上下居中 */
}
#table-dom {
  position: relative;
  .ant-spin-nested-loading .ant-spin-container .ant-table{
    max-height: inherit;
  }
}
::v-deep .ant-table-thead > tr > th {
  padding: 0px;
}
</style>
